import React, { useContext, useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { host } from "../../../../../utils";
import { AuthInfo } from "../../../../../App";
import Highcharts from "highcharts";
import PieChart from "highcharts-react-official";

export const Defects = (props) => {
  toast.configure();
  const { userId, permissions, userInfo } = useContext(AuthInfo);
  const planId = props.planningId;
  const actualProduction = props.actualProduction;
  const [formData, setFormData] = useState([]);
  const [defects, setDefects] = useState("Bend");
  const [reason, setReason] = useState("");
  const [defectCount, setDefectCount] = useState("");
  const [Loading, setLoading] = useState(true);
  const URL1 = `${host}/operator/plan/defects?planningId=${planId}`;
  const URL2 = `${host}/defects`;

  const handleClose = () => {
    props.setShowDefects(false);
  };

  const handleChange = (e) => {
    postDefect();
  };
  const getDefectsData = async () => {
    await axios.get(URL2).then((response) => {
      setFormData(response.data);
    });
  };

  useEffect(() => {
    getDefectsData();
    setLoading(false);
  }, []);

  if (Loading) {
    return <div className="App">Loading...</div>;
  }

  const postDefect = () => {
    if(!defects || !defectCount){
      alert("Please Specify Type and Count of defects")
      return;
    }
    
    fetch(URL1, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
        "Access-Control-Allow-Headers":
        "Origin, X-Requested-With, Content-Type, Accept",
      },
      body: JSON.stringify({
        userId: userId,
        planningId: planId,
        defectType: defects,
        defectCount,
        reasonsComment: reason,
        defectOwner: userInfo.profile.name || "defects modal"
      }),
      //  credentials: 'include'
    })
      .then((res) => {
        if (res.status == 200) {
          toast.success("Defect Added", {
            position: toast.POSITION.TOP_LEFT,
          });
          setDefectCount(null);
          setReason("");
          handleClose();
        } else if (res.status == 400 || res.status == 404) {
          toast.error("Request unsuccessful", {
            position: toast.POSITION.TOP_LEFT,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Request unsuccessful", {
          position: toast.POSITION.TOP_LEFT,
        });
      });
  };

  return (
    <>
      <Modal show={props.showDefects} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Defects</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label htmlFor="defectType">Defect Type</Form.Label>
            <Form.Select
              id="defectType"
              value={defects}
              onChange={(e) => {
                setDefects(e.target.value);
              }}
            >
              {formData.map((data) => {
                return <option key={data.code}>{data.description}</option>;
              })}
            </Form.Select>
          </Form.Group>

          <Form.Group>
            <Form.Label htmlFor="defectCount">Defect Count</Form.Label>
            <Form.Control
              value={defectCount}
              onChange={(e) => {

                if(e.target.value==""){
                  setDefectCount(e.target.value);
                  return;
                }

                if(isNaN(e.target.value)){
                  setDefectCount(defectCount);
                  return;
                }
                if (e.target.value <= 0) {
                  setDefectCount(defectCount);
                  return;
                }
                if (!isNaN(actualProduction)) {
                  if (actualProduction < e.target.value) {
                    alert("Defects can't be more than Actual Production");
                  } else {
                    setDefectCount(e.target.value);
                  }
                } else {
                  alert(
                    "Can't enter defects as NO Actual Production available."
                  );
                }
              }}
            />
          </Form.Group>
          <br>
          </br>

          <Form.Group>
            <Form.Label htmlFor="reasons">Reasons</Form.Label>
            <Form.Control
              as="textarea"
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
              }}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <button className="btn btn-default" onClick={handleClose}>
            Cancel
          </button>
          <button
            variant="primary"
            className="btn btn-primary"
            onClick={handleChange}
          >
            Update
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export function DefectsDistributionChart({ defectDistribution }) {
  let data = {};

  if (defectDistribution !== undefined) {
    for (let i = 0; i < defectDistribution.length; i++) {
      if (data[defectDistribution[i]["defectType"]] == undefined) {
        data[defectDistribution[i]["defectType"]] = {
          count: defectDistribution[i]["defectCount"],
        };
      } else {
        data[defectDistribution[i]["defectType"]]["count"] +=
          defectDistribution[i]["defectCount"];
      }
    }
  }

  let graphData = [];

  for (const key in data) {
    if (Object.hasOwnProperty.call(data, key)) {
      let sx = {
        y: data[key]["count"],
        name: key,
      };

      graphData.push(sx);
    }
  }

  const options = {
    chart: {
      type: "pie",
    },
    title: {
      text: "Defect Distribution",
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>: {point.percentage:.1f} %",
          style: {
            color: "black",
            fontSize: "18px",
          },
        },
      },
    },
    series: [
      {
        name: "",
        color: "#006600",
        lineWidth: 1,
        marker: {
          enabled: true,
          symbol: "circle",
          radius: 3,
          states: {
            hover: {
              enabled: true,
              lineWidth: 1,
            },
          },
        },
        data: graphData,
      },
    ],
  };

  return (
    <div>
      <PieChart highcharts={Highcharts} options={options} />
    </div>
  );
}

export default { Defects, DefectsDistributionChart };
